/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Select_File_LabelInputs */



/**
* | output |
* | --- |
* | "Select Subtitle File" |
*
* @param {Subtitle_Import_Select_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_select_file_label = /** @type {((inputs?: Subtitle_Import_Select_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Select_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner le fichier de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertiteldatei auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona file sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите файл субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar archivo de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择字幕文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕ファイルを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक फ़ाइल चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o arquivo de legenda")
	return /** @type {LocalizedString} */ ("Select Subtitle File")
});